<template>
    <div :class="{login_box:true,clearfloat:true}" style="height: 90%" >
        <div class="loginLeft">
             <img :src="loginWelcome" class="welcome_img" alt="万德付">
        </div>
       <div class="loginContent">
         <span style="font-weight: bold;margin-top: 25px;display: block;">账号登录</span>
         <el-form
             ref="loginForm"
             :model="loginForm"
             class="login-form"
             auto-complete="on"
             label-position="left">
           <div style="padding: 15px 10px 0px 10px">
             <el-form-item prop="username">
   
               <el-input
                   ref="username"
                   v-model="loginForm.username"
                   autocomplete="off"
                   placeholder="输入手机号"
                   style="width: 278px"
               ></el-input>
             </el-form-item>
             <el-form-item prop="password">
               <el-input
                   ref="password"
                   v-model="loginForm.password"
                   autocomplete="off"
                   :type="passwordType"
                   @keyup.native="handleKeyLogin"
                   placeholder="输入密码"
                   style="width: 278px !important;"
               ></el-input>
               <div class="show-pwd" @click="changetype">
                 <i
                     class="iconfont"
                     :class="passwordType == 'password'? 'icon-guanbi':'icon-xianshimima'"
                 ></i>
               </div>
             </el-form-item>
             <el-button
                 :loading="loading"
                 type="primary"
                 style="width:100%;background-color: #5111ee;border-color: #5111ee"
                 @click.native.prevent="handleLogin"
             >登录
             </el-button>
           </div>
         </el-form>
         <!--        <span class="wangjimima">忘记密码</span>-->
         <!--        <span style="display: block" class="read">阅读并接受《服务条款》和《隐私政策》</span>-->
       </div>
     </div>
</template>
<script>
import ElFormItem from "element-ui/packages/form/src/form-item";
import ElInput from "element-ui/packages/input/src/input";
import loginWelcome  from '@/assets/images/login_welcome.png';

export default {
    name:"login",
    components: {
        ElInput,
        ElFormItem
    },
    data() {
        return {
            baseTitle: '',
            passwordType: 'password',
            loginForm: {
                username: '',
                password: '',
            },
            loginRules: {
                username: [{required: true, message: '请输入账号', trigger: 'blur'}],
                password: [{required: true, message: '请输入密码', trigger: 'blur'}]
            },
            loading: false,
            loginWelcome,
        }
    },
    mounted() {
        if (this.$route.query.token) {
            this.loginForm.username = 'admin';
            this.loginForm.password = '';
            this.loginForm.token = this.$route.query.token;
            this.handleJumpHomePage();
        }
    },
    methods: {
        // 切换显示方式
        changetype() {
            if (this.passwordType === 'password') {
                this.passwordType = ''
            } else {
                this.passwordType = 'password'
            }
        },
        handleLogin() {//点击登录
            this.handleJumpHomePage();
        },
        handleKeyLogin(e) { //回车登录
            if (e.keyCode == 13) {
                this.handleJumpHomePage();
            }
        },
        handleJumpHomePage() { //处理跳转首页
            this.$api.post('/api/user/login', this.loginForm, res => {
                if (res.status == 200) {
                let that = this;
                let data = res.data;
                sessionStorage.setItem('token', data.token);
                sessionStorage.setItem('roles', data.data.role_code);
                sessionStorage.setItem('role_id', data.data.role_id);
                sessionStorage.setItem('user_name', data.data.user_name);
                sessionStorage.setItem('flag', 'open');
                sessionStorage.setItem('avatar_url', data.data.avatar_url);
                // sessionStorage.setItem('company', data.info.level == 0 ? data.info.realname : data.info.nickname);
                // sessionStorage.setItem('real_name', data.info.real_name);
                // sessionStorage.setItem('has_update_password', data.info.has_update_password);
                // sessionStorage.setItem('login_count', data.info.login_count);
                // sessionStorage.setItem('is_company', data.info.is_company);
                // sessionStorage.setItem('repayment_type', data.repayment_type);
                // sessionStorage.setItem('admin_id', data.info.id);
                this.$message({
                    type: 'success',
                    message: '登录成功',
                    duration: 1000,
                    onClose() {

                    that.$router.push({path: '/home'});
                    // location.href = '/admintest'
                    // is_update_password 1.需求修改 2.无需修改
                    // if (res.data.info.is_update_password == 2) {
                    //     that.$alert('系统检测到您的登录密码还是初始密码，为了您的账号安全请尽快修改登录密码!', '温馨提示', {
                    //         type: 'warning',
                    //         center: true,
                    //         confirmButtonText: '去修改',
                    //         confirmButtonClass: 'apply-button',
                    //         callback: action => {
                    //             if (action === 'confirm') {
                    //                 that.$router.push({ path: '/editPassword' });
                    //             }
                    //         }
                    //     });
                    // }
                    }
                });
                } else {
                this.$message.error(res.msg);
                }
            })
        }
    }
}
</script>
<style scoped lang='scss'>
.clearfloat:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
 }
  .clearfloat{
    zoom:1
  }
    .ogin-tab{
    width: 20%;
    }

    .logoImage {
        height: 60px;
        float: left;
        margin-left: 10px;
        margin-top: 10px;
    }

    .textLogo {
        float: left;
        margin-top: 17px;
        text-align: center;
    }

    .textNumb {
        float: right;
        margin-top: 25px;
        margin-right: 20px;
        font-size: 20px;
        font-weight: bold;
    }

    .text2 {
        float: left;
        margin-top: 30px;
        margin-left: 15px;
        font-size: 15px;
        font-weight: bold;
    }

    .rightImg {
        position: absolute;
        top: 25%;
        left: 25%;
    }

    .imgright {
        height: 250px;
    }


    .login_box{
            position: relative;
            .loginLeft{
                width: 50%;
                float: left;
            .welcome_img{
                position: absolute;
                top: 130px;
                left: 20%;
                width: 400px;
            }
        }    
        .loginContent {
            width: 50%;
            float: left;
            padding-bottom: 40px;
            background-color: #ffffff;
            box-shadow: 0 0 20px -1px rgba(0, 0, 0, 0.05);
            text-align: center;
            width: 300px;
            position: absolute;
            top: 157px;
            right: 25%;
            border-radius: 15px;
        .read {
            margin: 20px 0;
            padding: 0 10px;
            display: block;
            font-size: 15px;
            font-weight: bold;
        }

        .wangjimima {
            display: block;
            text-align: left;
            padding: 5px 10px 0;
            font-size: 10px;
        }



        }
    }


    .header-title {
        text-align: center;
        display: table;
        height: 12%;
        margin: 0 auto;
    }

    .login-form {
        .login-title {
        font-family: "Microsoft YaHei";
        font-size: 28px;
        text-align: center;
        margin-bottom: 30px;
        letter-spacing: 5px;
        color: white;
        }

        .login-titles {
        font-family: "Microsoft YaHei";
        text-align: center;
        font-size: 16px;
        margin-bottom: 30px;
        color: white;
        }

        .el-form-item {
        border: 1px solid;
        //background: rgba(0, 0, 0, 0.5);
        border-radius: 5px;
        color: #454545;
        background-color: white;
        }

        .svg-container {
        padding: 0px 0px 0px 7.5px;
        color: #666;
        vertical-align: middle;
        //display: inline-block;
        }

        .show-pwd {
        position: absolute;
        right: 14px;
        top: 2px;
        color: #333;
        cursor: pointer;
        user-select: none;

        .iconfont {
            font-size: 20px;
        }
        }
    }

    .el-form-item {
        margin-bottom: 22px;
    }

    .el-input {
        width: 100% !important;
        height: 30px !important;
    }




    ::v-deep .el-input__inner {
    height: 30px !important;
    }

    ::v-deep .el-form-item__content {
    line-height: 30px !important;
    width: 278px !important;
    }

    ::v-deep .el-button {
    padding: 8px 20px !important;
    }

    ::v-deep .el-divider--vertical {
    float: left;
    display: block;
    margin: 20px 0 0 15px;
    height: 2.5em;
    width: 2.5px;
    color: #000000;
    }
</style>